import { initializeApp, getApp, getApps } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

import options from "@/firebase/options";

const app = getApps().length > 0 ? getApp("minhamola-otp") : initializeApp(options, "minhamola-otp");
const auth = getAuth(app);

const mountRecaptchaVerifier = (element) => {
  window.recaptchaVerifier = new RecaptchaVerifier(element, { size: "invisible" }, auth);
};

const sendOTP = async (phoneNumber) => {
  try {
    const result = await signInWithPhoneNumber(auth, phoneNumber, window.recaptchaVerifier);
    window.result = result;
    return result;
  } catch (error) {
    return error;
  }
};

const verifyOTP = async (OTP) => {
  try {
    return await window.result.confirm(OTP);
  } catch (error) {
    return error;
  }
};

export { mountRecaptchaVerifier, sendOTP, verifyOTP };